import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { NEW_RUN_SECTIONS } from '~/features/catalog-enrichment/types/new-run.types';

const NewRunPage = lazy(() => import('~/features/catalog-enrichment/pages/new-run-page'));

/** The New batch form's search (`?section=`, `?copyFrom=`), as `runs/new` validates it. */
const newAuditSearchSchema = z.object({
  section: z.enum(NEW_RUN_SECTIONS).optional().catch(undefined),
  copyFrom: z.string().optional().catch(undefined),
});

/** New feed audit: the New batch form in audit mode — flow locked to FEED_AUDIT, the per-audit
 *  product cap, no required scope filters. On 202 it opens the new run's batch page. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/feed-audit/new')({
  validateSearch: newAuditSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <NewRunPage mode="audit" />
    </Suspense>
  ),
});
